/**
 * Hook: useDeletePipeline
 * Deleta (soft delete) uma pipeline marcando como inativa
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export function useDeletePipeline() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (pipelineId: string) => {
      const { error } = await supabase
        .from('pipelines')
        .update({ ativa: false })
        .eq('id', pipelineId);

      if (error) {
        throw new Error(`Erro ao deletar pipeline: ${error.message}`);
      }

      return pipelineId;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['pipelinesList'] });
      queryClient.invalidateQueries({ queryKey: ['pipelineBoard'] });
    }
  });
}
